(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-alt"]) return;
  try {
    

  document.querySelectorAll('.text-megamenu').forEach(megamenu => {
    megamenu.querySelectorAll('.text-megamenu-item a').forEach(item => {
        const text = item.querySelector('.text-megamenu-subtext-wrap');
      item.addEventListener('mouseenter', () => {
        item.classList.add('active');
        megamenu.classList.add('active');
        text.style.height = text.scrollHeight + 'px';
      })
      item.addEventListener('mouseleave', () => {
        item.classList.remove('active');
        megamenu.classList.remove('active');
        text.style.height = 0;
      })
    })
  })
  document.querySelectorAll('.nav-megamenu').forEach(megamenu => {
    megamenu.querySelectorAll('.cc-accordion-item').forEach(item => {
      item.addEventListener('click', () => {
        if(item.attributes.open == undefined){
          megamenu.querySelector('.cc-accordion-item[open] .cc-accordion-item__title')?.click();
          megamenu.classList.add('active');
        } else {
          megamenu.classList.remove('active');
        }
      })
      item.addEventListener('mouseenter', () => {
        item.querySelector('.cc-accordion-item__title').click();
      })
      item.querySelector('.cc-accordion-item__title a').addEventListener('click', function(e) {
        e.stopPropagation();
        window.location.href = this.href;
      })
    })
  })
  document.querySelectorAll('.prod-megamenu').forEach(megamenu => {
    const container =  megamenu.querySelector('.prod-megamenu_content-wrap')
    megamenu.querySelectorAll('.prod-megamenu_anchor-link').forEach(anchor => {
      const item = megamenu.querySelector(`.prod-megamenu_item[data-id="${anchor.dataset.id}"]`)
      anchor.addEventListener('mouseenter', () => {
        if(!anchor.classList.contains('active')){
          megamenu.querySelector('.prod-megamenu_anchor-link.active').classList.remove('active');
          megamenu.querySelector('.prod-megamenu_item.active').classList.remove('active');
          anchor.classList.add('active');
          item.classList.add('active');
          container.style.height = item.offsetHeight + 'px';
        } 
      })
      if(item.classList.contains('active')){
        container.style.height = item.offsetHeight + 'px';
      }
    })
  })
  
  let abortController;
  function fetchOvaSearch(value){
    if (abortController) {
        abortController.abort();
    }

    abortController = new AbortController();
    const signal = abortController.signal;
    $('.ova-search_content').addClass('ajax-loading');
    fetch(theme.routes.search_url+'?q='+value+'&type=product', {signal}).
      then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.text();
      }).
      then((response) => {
        const $parsed = $(`<div>${response}</div>`);

        $('.ova-search_content').html($parsed.find('[data-ajax-container="products"]').html());
        $('.ova-search_content').removeClass('ajax-loading');
        theme.initAnimateOnScroll();
        $('.ova-search_content product-block').each(function(i){
          gsap.fromTo(this, { opacity: 0}, { opacity: 1, duration: 0.3, delay: 0.1*(i%(window.matchMedia("(max-width: 767px)").matches?2:4)),scrollTrigger: {
            trigger: this,
            scroller: '.ova-search_container',
          }})
        })
      });
  }
  $('body').on('submit', '.header-search__form', function(e){
    e.preventDefault();
    // fetchOvaSearch($(this).find('.header-search__input').eq(0).val());
  })
  $('body').on('input', '.header-search__input', function(e){
    // if (e.key !== 'Enter') {
      fetchOvaSearch($(this).val());
    // }
  });
  let hadSticky;
  let addedWhite;
  let openSearch;
  $('body').on('focus', '.header-search__input', function(e){
    $('.ova-search_container').scrollTop(0);
    $("body").addClass('ova_search');
    hadSticky = document.body.classList.contains('header--sticky');
    addedWhite = !document.body.classList.contains('white-header');
    document.body.classList.remove('header--sticky', 'header--sticky--show')
    document.body.classList.add('white-header')
    $('.mobile-navigation-drawer').scrollTop(0)
    // Add any padding necessary to the body to compensate for the scrollbar that just disappeared
    var scrollDiv = document.createElement('div');
    scrollDiv.className = 'popup-scrollbar-measure';
    document.body.appendChild(scrollDiv);
    var scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    if (scrollbarWidth > 0) {
      $('body').css('padding-right', scrollbarWidth + 'px');
    }
    openSearch = true;
  });
  $('body').on('click','.ova-search_close, .mobile-nav-toggle',function(e){
    e.preventDefault();
    if(!openSearch) return;
    document.body.classList.remove('header--sticky');
    if(hadSticky){ document.body.classList.add('header--sticky', 'header--sticky--show')}
    if(addedWhite){ document.body.classList.remove('white-header')}
    $(document).find('.header-search__input').val("")
    fetchOvaSearch("");
    $("body").removeClass('ova_search');
    $('body').css('padding-right', '0px');
    openSearch = false;
  });
  new Swiper('.prod-megamenu_item-prod-swiper.swiper-active', {
    slidesPerView: 'auto',
    freeMode: {
      enabled: true,
      sticky: true,
      momentumRatio: 0.8,
    },
    speed: 400,
  });

  // Zoekicoon mobiel header: opent het menu en zet de cursor direct in het zoekveld
  let searchViaHeaderIcon = false;
  $('body').on('click', '.header-search-toggle', function(e){
    e.preventDefault();
    const menuToggle = document.querySelector('.logo-area__right__inner .mobile-nav-toggle');
    if (!menuToggle) return;
    if (document.body.classList.contains('ova_search')) {
      // Zoeken staat al open: sluit zoeken en menu in een keer
      menuToggle.click();
      searchViaHeaderIcon = false;
      return;
    }
    if (!document.body.classList.contains('reveal-mobile-nav')) {
      menuToggle.click();
    }
    searchViaHeaderIcon = true;
    const input = document.querySelector('.mobile-navigation-drawer .header-search__input');
    if (input) input.focus();
  });
  $('body').on('click', '.mobile-nav-toggle', function(){
    searchViaHeaderIcon = false;
  });
  $('body').on('click', '.ova-search_close', function(){
    // Via het icoon geopend: kruisje sluit ook het menu, zodat je terug bent op de pagina
    if (!searchViaHeaderIcon) return;
    searchViaHeaderIcon = false;
    document.body.classList.remove('reveal-mobile-nav', 'reveal-mobile-nav--revealed');
  });
  // Zoekresultaten op mobiel direct onder het zoekveld laten beginnen
  function positionOvaSearchMobile(){
    const container = document.querySelector('.ova-search_container');
    if (!container) return;
    if (!window.matchMedia('(max-width: 767px)').matches || !document.body.classList.contains('reveal-mobile-nav')) {
      container.style.removeProperty('--offset');
      return;
    }
    const btn = document.querySelector('.mobile-navigation-drawer .header-alt__drawer-btn');
    const form = document.querySelector('.mobile-navigation-drawer .header-search__form');
    const anchor = (btn && btn.offsetParent !== null) ? btn : form;
    if (!anchor) return;
    const bottom = Math.ceil(anchor.getBoundingClientRect().bottom);
    if (bottom > 0) container.style.setProperty('--offset', (bottom + 6) + 'px');
  }
  $('body').on('focus', '.mobile-navigation-drawer .header-search__input', function(){
    positionOvaSearchMobile();
    setTimeout(positionOvaSearchMobile, 350);
    setTimeout(positionOvaSearchMobile, 750);
  });
  $(window).on('resize', function(){
    if (document.body.classList.contains('ova_search')) positionOvaSearchMobile();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadRelatedProductsIntoSection = function() {
  // Look for an element with class 'related-products'
  var relatedProductsSection = document.querySelector('.related-products');
  if (relatedProductsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", relatedProductsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      relatedProductsSection.innerHTML = container.querySelector('.related-products').innerHTML;
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// Fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadRelatedProductsIntoSection();
  }
});
// Fetch the products on page load
loadRelatedProductsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
